import { ShelfTypeEnum } from '@soundxyz/utils/const';
import { gql, MoreDiscoveredOnDocument, SortOrder, useInfiniteQuery } from '@graphql/reactQuery';

/*#__PURE__*/ gql(/* GraphQL */ `
  query MoreDiscoveredOn(
    $releaseId: UUID!
    $pagination: ReleaseShelvesCursorConnectionArgs
    $filter: ReleaseShelvesFilter
  ) {
    release(id: $releaseId) {
      id
      shelves(pagination: $pagination, filter: $filter) {
        edges {
          node {
            id
            type
            ...PlaylistCardDetails
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`);

export const useSongAppearsOn = ({
  releaseId,
  initialPageSize,
}: {
  releaseId: string;
  initialPageSize: number;
}) => {
  const {
    orderedList: playlists,
    loadMoreNextPage: loadMore,
    isInitialLoading,
    isFetchingNextPage,
    hasNextPage = false,
  } = useInfiniteQuery(MoreDiscoveredOnDocument, {
    filterQueryKey: {
      releaseId,
    },
    getNextPageParam({ data: { release } }) {
      return release?.shelves.pageInfo.hasNextPage && { after: release.shelves.pageInfo.endCursor };
    },
    variables({ pageParam }) {
      return {
        filter: {
          type: [ShelfTypeEnum.DEFAULT],
        },
        pagination: {
          first: initialPageSize,
          after: pageParam?.after || null,
          sort: { score: SortOrder.Desc },
        },
        releaseId,
      };
    },
    list({ release }) {
      return release?.shelves.edges.map(edge => edge.node);
    },
    uniq({ id }) {
      return id;
    },
    staleTime: 0,
  });

  return { playlists, loadMore, isInitialLoading, isFetchingNextPage, hasNextPage };
};
